import { t } from "@/i18n-js/instance";
import { isAnnual } from "@/react/helpers/planHelpers";
import type { Plan } from "@circle-react/types";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";

interface PlanCardProps {
  isLoading: boolean;
  plan: Plan;
}

export const PlanCard = ({ plan, isLoading }: PlanCardProps) => {
  if (isLoading) {
    return (
      <div className="bg-primary border-primary flex h-32 w-full items-center justify-center rounded-b-lg border">
        <Loader />
      </div>
    );
  }

  if (!plan) {
    return null;
  }

  const getAmountTranslationKey = () => {
    if (isAnnual(plan.interval)) {
      return "settings.ai_actions.modal.annual_amount";
    }

    return "settings.ai_actions.modal.monthly_amount";
  };

  return (
    <div className="bg-primary border-primary rounded-b-xl border p-4">
      <div className="mb-1 flex items-center justify-between">
        <Typography.LabelLg weight="semibold">
          {plan.display_name}
        </Typography.LabelLg>
        <div className="flex flex-row items-center gap-1 align-middle">
          <Typography.LabelMd weight="bold">
            {plan.display_base_monthly_amount}
          </Typography.LabelMd>
          <Typography.BodyMd
            weight="font-normal"
            color="text-slate-700 dark:text-slate-300"
            size="text-sm"
          >
            {t("settings.ai_actions.modal.monthly_interval")}
          </Typography.BodyMd>
        </div>
      </div>
      <Typography.LabelXs>
        {t(
          getAmountTranslationKey(),
          isAnnual(plan.interval)
            ? { dollar_amount: plan.annual_base_amount_with_currency }
            : {},
        )}
      </Typography.LabelXs>
    </div>
  );
};
